import React, { Component, PropTypes } from 'react'
import Radium from 'radium'
import Color from 'color'
import debounce from 'lodash.debounce'
import { Helmet } from 'react-helmet'
import scrollToComponent from 'react-scroll-to-component';
import vid0 from '../components/assets/demo_next.mp4'
import timelineBase from '../components/assets/featIllos/timeline_base.svg'
import timelineTimeline from '../components/assets/featIllos/timeline_timeline.svg'
import timelineToggle from '../components/assets/featIllos/timeline_toggle.svg'
import interactBase from '../components/assets/featIllos/interact_base.svg'
import interactStates from '../components/assets/featIllos/interact_states.svg'
import interactExpression from '../components/assets/featIllos/interact_expression.svg'
import pubBase from '../components/assets/featIllos/pub_base.svg'
import pubModal from '../components/assets/featIllos/pub_modal.svg'
import pubBtns from '../components/assets/featIllos/pub_btns.svg'
import sketch from '../components/assets/sketch.svg'
import figma from '../components/assets/figma.svg'
import ai from '../components/assets/illustrator.svg'
import svg from '../components/assets/svg.svg'
import kwame from '../components/assets/quote_assets/kwame.png'
import stu from '../components/assets/quote_assets/stu.png'
import josh from '../components/assets/quote_assets/josh.png'
import evan from '../components/assets/quote_assets/evan.png'
import alvaro from '../components/assets/quote_assets/alvaro.png'
import khan from '../components/assets/quote_assets/khan.svg'
import sus from '../components/assets/quote_assets/sus.svg'
import bh from '../components/assets/quote_assets/bh.png'
import lottie from '../components/assets/targets/lottie.svg'
import android from '../components/assets/targets/android.svg'
import ios from '../components/assets/targets/ios.svg'
import vue from '../components/assets/targets/vue.svg'
import react from '../components/assets/targets/react.svg'
import angular from '../components/assets/targets/angular.svg'
import { KeyframeSVG, HeartSVG, RightArrowSVG } from '../components/assets/icons'
import { HeroSVG } from '../components/assets/herobg'
import { CTASVG } from '../components/assets/ctabg'
import { GoogleSVG, BenzSVG, LegoSVG, DeloitteSVG, TripAdvisorSVG, UberSVG } from '../components/assets/companies'
import AnimatorWebsiteIcon1 from '@haiku/tina-animatorwebsiteicon1/react'
import AnimatorWebsiteIcon2 from '@haiku/tina-animatorwebsiteicon2/react'
import AnimatorWebsiteIcon3 from '@haiku/tina-animatorwebsiteicon3/react'
import AnimatorLogo from '@haiku/zack4-animatorlogo/react'
import { colors, colorsMapped, spacing, sizing, typography, borderRadii, shadows } from '../components/assets/shibui';
import SS from '../components/assets/shared-styles'
import { Parallax } from 'react-scroll-parallax'
import Link from 'gatsby-link'
import Carousel from 'nuka-carousel'
import MobileContent from '../components/mobile-content'
import Navbar from '../components/navbar'
import CardWithIcon from '../components/card-with-icon'

const windowPresent = (typeof window !== 'undefined')

const S = {
  page: {
    backgroundColor: colors.ivory.color,
    fontFamily: "'Poppins', sans-serif",
    color: colors.midnight.color,
    overflowX: 'hidden'
  },
  top: {
    transition: 'opacity linear 300ms',
    position: 'relative',
    overflowX: 'hidden'
  },
  hero: {
    position: 'relative',
    zIndex: 1,
    height: sizing.xl,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translateY(-44px)',
    '@media screen and (max-width: 870px)': {
      minHeight: 'calc(100vh + 330px)',
      width: '100%'
    },
  },
  heroHolster: {
    marginTop: -spacing.lg,
    width: '100%'
  },
  haikuHolster: {
    height: 170,
    margin: '0 auto',
    '@media screen and (max-width: 870px)': {
      maxWidth: '93%',
    },
  },
  bg: {
    position: 'absolute',
    zIndex: -1,
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -20%)'
  },
  section: {
    position: 'relative',
    fontSize: 20,
    lineHeight: '1.8em',
    width: '100%',
    maxWidth: sizing.xxl,
    margin: '0 auto',
  },
  sectionQuotes: {
    maxHeight: 340,
    marginBottom: sizing.sm,
    '@media screen and (max-width: 670px)': {
      display: 'none'
    },
  },
  heartedCard: {
    backgroundColor: colors.ivoryMuted.color,
    borderRadius: borderRadii.modal,
    width: '100%',
    maxWidth: sizing.xxxl,
    position: 'absolute',
    bottom: 30,
    padding: `${spacing.md + spacing.xs}px ${spacing.lg}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '@media screen and (max-width: 870px)': {
      justifyContent: 'center',
      bottom: '0'
    },
  },
  hearted: {
    marginRight: spacing.md,
    marginLeft: spacing.sm,
    '@media screen and (max-width: 870px)': {
      flex: '0 0 100%',
      marginBottom: spacing.lg,
      textAlign: 'center'
    }
  },
  geef: {
    maxWidth: sizing.xxxl,
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
    margin: '0 auto ' + spacing.xxl + 'px',
  },
  vidHolster: {
    borderRadius: borderRadii.modal,
    overflow: 'visible',
    maxWidth: '100%',
    maxHeight: 'calc(100vh - 30px)',
    boxShadow: shadows.modalOnDark.boxShadow,
  },
  cardsHolster: {
    marginTop: spacing.xl,
    display: 'flex',
    flexWrap: 'wrap'
  },
  description: {
    fontSize: '1.18rem'
  },
  cardTitle: {
    textAlign: 'center'
  },
  divider: {
    margin: sizing.xs,
    textAlign: 'center',
    '@media screen and (max-width: 758px)': {
      opacity: 0,
      margin: spacing.lg,
    }
  },
  splitter: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto ' + spacing.xl + 'px'
  },
  split: {
    width: '50%',
    '@media screen and (max-width: 870px)': {
      width: '100%',
    }
  },
  splitSplitter: {
    display: 'flex',
    '@media screen and (max-width: 500px)': {
      flexWrap: 'wrap'
    }
  },
  lined: {
    borderRight: '1px solid ' + colorsMapped.borderColor.color
  },
  targetsTextHolster: {
    paddingLeft: spacing.xl,
    paddingRight: spacing.xl,
  },
  splitText: {
    width: '50%',
    paddingLeft: spacing.xxl,
    paddingRight: spacing.lg,
    '@media screen and (max-width: 870px)': {
      width: '100%',
      paddingLeft: spacing.md,
    },
  },
  splitTextLeft: {
    width: '50%',
    paddingRight: spacing.lg,
    paddingLeft: spacing.xl,
    '@media screen and (max-width: 870px)': {
      order: 1,
      width: '100%',
      paddingLeft: spacing.md,
      paddingRight: spacing.md,
    },
  },
  circleFloat: {
    borderRadius: borderRadii.avatar,
    boxShadow: shadows.card.boxShadow,
    width: 77,
    height: 77,
    padding: spacing.md,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  avatarColumn: {
    minWidth: 80,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media screen and (max-width: 500px)': {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-around',
    }
  },
  orderReverse: {
    '@media screen and (max-width: 500)': {
      order: 1 + '!important',
    },
  },
  cardLink: {
    color: colors.midnight.color
  },
  bullets: {
    fontSize: 16
  },
  quote: {
    fontSize: 20
  },
  quoteCompany: {
    height: 60,
    marginTop: spacing.xs,
    paddingTop: spacing.md
  },
  quoteCredsLeft: {
    float: 'left',
    borderRight: '1px solid ' + colorsMapped.borderColor.color,
    paddingRight: spacing.lg,
  },
  quoteCredsRight: {
    marginLeft: spacing.lg,
    float: 'left',
  },
  personHolster: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  name: {
    textAlign: 'left',
    paddingLeft: spacing.lg,
    textTransform: 'uppercase',
    marginTop: 12,
    marginBottom: 0,
  },
  position: {
    paddingLeft: spacing.lg,
    textAlign: 'left',
    fontWeight: 700,
    fontSize: '.9rem',
    marginTop: 0
  },
  ctaSection: {
    position: 'relative',
    padding: spacing.xl,
    marginTop: sizing.sm,
    overflow: 'hidden',
    backgroundColor: colors.graphite.color,
    boxShadow: `0 0 60px 0 ${Color(colors.amethyst50.color).alpha(0.5)}`,
    '@media screen and (max-width: 758px)': {
      display: 'none'
    }
  },
  avatarHolster: {
    width: 69,
    height: 69
  },
  arrivals: {
    transition: `transform 700ms 'cubic-bezier(0.03, 0.07, 0.12, 1.07)', opacity 400ms`,
    transform: 'translateY(0)'
  },
  arrival2: {
    fontSize: '2.24rem',
    transition: `transform 700ms 'cubic-bezier(0.03, 0.07, 0.12, 1.07)' 160ms, opacity 400ms 160ms`,
  },
  arrival3: {
    transition: `transform 700ms 'cubic-bezier(0.03, 0.07, 0.12, 1.07)' 320ms, opacity 400ms 320ms`,
  },
  airborne: {
    transform: 'translateY(40px)',
    opacity: 0
  },
  inlineCode: {
    fontFamily: 'courier, monospace',
    backgroundColor: colors.seattleMuted.color,
    borderRadius: borderRadii.input,
    padding: '0 ' + spacing.sm + 'px'
  },
}

class Animator extends Component {
  constructor() {
    super()

    this.state = {
      finishedLoad: false,
      AnimatorLogo: null,
      windowWidth: windowPresent ? window.innerWidth : 1920,
      windowHeight: windowPresent ? window.innerHeight : 1920,
    }
  }

  static contextTypes = {
    parallaxController: PropTypes.object.isRequired,
  }

  componentDidMount() {
    // this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920 })
    this.setState({ finishedLoad: true })
    // windowPresent && window.addEventListener("resize", this.updateDimensions)

    if (this.props.location.hash) {
      scrollToComponent(this[this.props.location.hash.substr(1)], { align: 'top' })
    }

    this.context.parallaxController.update()
  }

  componentWillUnmount() {
    // windowPresent && window.removeEventListener("resize", this.updateDimensions)
    // if (this.orientationHandler) windowPresent && window.removeEventListener("deviceorientation", this.orientationHandler)
  }

  updateDimensions = debounce(() => {
    this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920, windowHeight: windowPresent ? window.innerHeight : 1920 })
  }, 40)

  render() {

    return (
      <div
        id="top"
        style={[S.page, { opacity: this.state.finishedLoad ? 1 : 0 }]}
        onMouseMove={this.mouseMoveCallback}>
        <Helmet>
          <title>Haiku Animator | Create engaging animations for any app or website.</title>
          <meta name="description" content="Make Lottie animations or dynamic web components using Animator's timeline, stage, and design tool integrations." />
        </Helmet>
        <Navbar location="animator" />
        <section id="hero" style={S.hero}>
          <div style={S.bg}>
            <HeroSVG offset={this.state.windowWidth < 800 ? '-20%' : '-6%'} />
          </div>
          <div style={[SS.container, SS.container.narrow, SS.centerer]}>
            <div style={S.heroHolster}>
              <div
                style={S.haikuHolster}
                onClick={() => { this.state.AnimatorLogo.getDefaultTimeline().gotoAndPlay(0) }}>
                <AnimatorLogo
                  haikuStates={{ fgColor: { value: colors.ivory.color } }}
                  onHaikuComponentDidMount={(component) => this.setState({ AnimatorLogo: component })}
                  sizing="contain" />
              </div>
              <h4 style={[
                SS.heading4,
                { fontSize: '1.7rem', color: colors.ivory.color },
                SS.centerer,
                S.arrivals,
                S.arrival2,
                !this.state.finishedLoad && S.airborne,
                { margin: `${spacing.lg}px auto` }
              ]}>
                Create engaging animations <br />for any app or website.
              </h4>
              <a
                key="cta1"
                href="https://github.com/HaikuTeam/animator/"
                style={[
                  SS.btn,
                  SS.cta,
                  S.arrivals,
                  S.arrival3,
                  !this.state.finishedLoad && S.airborne
                ]}>
                Download on Github
              </a>
              <p style={{color: colors.ivory.color}}><span style={[SS.badge, S.badgePositioning]}>New!</span> Haiku Animator goes open-source: <a href="/blog/open-source">read more</a></p>
            </div>
          </div>
          <div style={S.heartedCard}>
            <span style={S.hearted}>
              <HeartSVG />'d by lovely folks at
            </span>
            <DeloitteSVG />
            <UberSVG />
            <LegoSVG />
            <GoogleSVG />
            <BenzSVG />
            <TripAdvisorSVG />
          </div>
        </section>

        <section id="geef" style={S.geef}>
          <video
            ref="vid0"
            style={S.vidHolster}
            onLoadedData={() => this.context.parallaxController.update()}
            loop autoPlay muted playsInline preload="metadata">
            <source src={vid0} type="video/mp4" />
          </video>
        </section>

        <section id="drawing-tools" style={S.q}>
          <div style={[SS.container, SS.container.narrow, SS.centerer]}>
            <h2 style={[typography.heading2, SS.centerer]}>
              Motion design for your team's workflow
            </h2>
            <p style={S.description}>
              Animations are hard.  Collaborating between designers and developers, even harder.<br />
              Luckily for you, Haiku Animator lets you bring motion design to production, starting with <span style={{ fontStyle: 'italic' }}>your</span> design tools and finishing with <span style={{ fontStyle: 'italic' }}>your</span> codebase.
            </p>
          </div>

          <div style={[SS.container, SS.centerer]}>
            <div style={S.cardsHolster}>
              <div key='1' style={[SS.card, SS.flexDivision]}>
                <Link to="/learn/#drawing">
                  <img src={sketch} alt="sketch app" />
                  <div style={[SS.heading4, S.cardTitle]}>Sketch</div>
                  <span style={SS.btnLink}>Learn more <RightArrowSVG style={SS.rightArrow} /></span>
                </Link>
              </div>
              <div key='2' style={[SS.card, SS.flexDivision]}>
                <Link to="/learn/#drawing">
                  <img src={figma} alt="figma" />
                  <div style={[SS.heading4, S.cardTitle]}>Figma</div>
                  <span style={SS.btnLink}>Learn more <RightArrowSVG style={SS.rightArrow} /></span>
                </Link>
              </div>
              <div key='3' style={[SS.card, SS.flexDivision]}>
                <Link to="/learn/#drawing">
                  <img src={ai} alt="adobe illustator" />
                  <div style={[SS.heading4, S.cardTitle]}>Illustrator</div>
                  <span style={SS.btnLink}>Learn more <RightArrowSVG style={SS.rightArrow} /></span>
                </Link>
              </div>
              <div key='4' style={[SS.card, SS.flexDivision]}>
                <Link to="/learn/#drawing">
                  <img src={svg} alt="svg logo" />
                  <div style={[SS.heading4, S.cardTitle]}>SVG</div>
                  <span style={SS.btnLink}>Learn more <RightArrowSVG style={SS.rightArrow} /></span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <div style={S.divider}>
          <KeyframeSVG />
        </div>

        <section id="features">
          <div id="timeline-n-code" style={[SS.container, S.splitter]}>
            <div style={[S.split, { maxHeight: 380, position: 'relative' }]}>
              <Parallax
                slowerScrollRate
                offsetYMax={4}
                offsetYMin={-4}
                styleOuter={{ transform: 'translate(0, 20px)' }}>
                <img src={timelineBase} />
              </Parallax>
              <Parallax
                offsetYMax={50}
                offsetYMin={-50}
                styleOuter={{ transform: 'translate(0, -60%)', width: '105%' }}>
                <img src={timelineTimeline} />
              </Parallax>
              <Parallax
                offsetYMax={17}
                offsetYMin={-17}
                styleOuter={{ transform: 'translate(97%, -610%)', width: '43%' }}>
                <img src={timelineToggle} />
              </Parallax>
            </div>
            <div style={S.splitText}>
              <h3 style={typography.heading3}>Timeline & code mode</h3>
              <p style={S.description}>With Timeline, choreograph animations in your designs visually. Sequence and animate elements using the built-in easing curves library, or finesse the details with the custom curve editor.</p>
              <p style={S.description}>You can also animate directly from code, using any code editor of your choice, or using Animator’s built-in Code mode.</p>
            </div>
          </div>
          <div id="interactivity" style={[SS.container, S.splitter]}>
            <div style={S.splitTextLeft}>
              <h3 style={typography.heading3}>Interactivity</h3>
              <p style={S.description}>Add interactivity to your designs with Haiku's easy-to-use, beginner-friendly scripting tools.</p>
              <p style={S.description}>
                If you can write a spreadsheet formula, you can create interactions in Animator!</p>
              <Link to="/learn/#interactivity" style={SS.btnLink}>Learn more <RightArrowSVG style={SS.rightArrow} /></Link>
            </div>
            <div style={[S.split, { maxHeight: 380, position: 'relative' }]}>
              <Parallax
                slowerScrollRate
                offsetYMax={4}
                offsetYMin={-4}
                styleOuter={{ transform: 'translate(0, 20px)' }}>
                <img src={interactBase} />
              </Parallax>
              <Parallax
                offsetYMax={30}
                offsetYMin={-30}
                styleOuter={{ transform: 'translate(-10%, -100%)', width: '34%' }}>
                <img src={interactStates} />
              </Parallax>
              <Parallax
                offsetYMax={20}
                offsetYMin={-20}
                styleOuter={{ transform: 'translate(60%, -260%)', width: '53%' }}>
                <img src={interactExpression} />
              </Parallax>
            </div>
          </div>
          <div id="embedding" style={[SS.container, S.splitter]}>
            <div style={[S.split, { maxHeight: 380, position: 'relative' }]}>
              <Parallax
                slowerScrollRate
                offsetYMax={4}
                offsetYMin={-4}
                styleOuter={{ transform: 'translate(0, 20px)' }}>
                <img src={pubBase} />
              </Parallax>
              <Parallax
                offsetYMax={20}
                offsetYMin={-30}
                styleOuter={{ transform: 'translate(10%, -64%)', width: '55%' }}>
                <img src={pubModal} />
              </Parallax>
              <Parallax
                offsetYMax={20}
                offsetYMin={-20}
                styleOuter={{ transform: 'translate(110%, -620%)', width: '53%' }}>
                <img src={pubBtns} />
              </Parallax>
            </div>
            <div style={S.splitText}>
              <h3 style={typography.heading3}>Publishing & embedding</h3>
              <p style={S.description}>Animator delivers your animations to your codebase with convenient shareable links and embed instructions for different kinds of codebases.</p>
              <p style={S.description}>Want GIFs or videos instead of code?  Lucky you, they're just an "Export" away.</p>
            </div>
          </div>
        </section>

        <div style={S.divider}>
          <KeyframeSVG />
        </div>

        <section id="code" style={S.sectionCode}>
          <div style={[SS.container, SS.container.narrow, SS.centerer]}>
            <h2 style={[typography.heading2, SS.centerer, { marginBottom: spacing.xl }]}>Loved by designers &amp; developers alike</h2>
          </div>
          <div style={[SS.container, S.splitter]}>
            <div style={[S.split, S.splitSplitter, S.lined]}>
              <div style={S.avatarColumn}>
                <div style={S.circleFloat}><img src={lottie} alt="lottie" /></div>
                <div style={S.circleFloat}><img src={ios} alt="ios" /></div>
                <div style={S.circleFloat}><img src={android} alt="android" /></div>
              </div>
              <div style={S.targetsTextHolster}>
                <h3 style={SS.heading4}>Native iOS and Android animations, powered by Lottie</h3>
                <p style={S.description}>Haiku Animator is the premier solution for creating cross-platform UI animations, with iOS and Android rendering powered by <a key='lotto' style={SS.linkNaked} href="https://airbnb.design/lottie/" target="_blank">Airbnb's open-source Lottie</a> engine.</p>
                <p style={SS.note}>*Lottie has certain <a key='limits' style={SS.linkNaked} target="_blank" href="https://docs.haiku.ai/embedding-and-using-haiku/lottie.html#limitations">limitations</a>.</p>
              </div>
            </div>
            <div style={[S.split, S.splitSplitter]}>
              <div style={S.targetsTextHolster}>
                <h3 style={SS.heading4}>Works with your codebase &amp; workflow</h3>
                <p style={S.description}>Design once, embed anywhere. Haiku animations work with all major browsers and integrates with any web codebase, with first-class support for React, Vue, and Angular. </p>
              </div>
              <div style={[S.avatarColumn, S.orderReverse]}>
                <div style={S.circleFloat}><img src={react} alt="react" /></div>
                <div style={S.circleFloat}><img src={vue} alt="vue" style={{ transform: 'translateY(4px)' }} /></div>
                <div style={S.circleFloat}><img src={angular} alt="angular" /></div>
              </div>
            </div>
          </div>

        </section>

        <div style={S.divider}>
          <KeyframeSVG />
        </div>

        <section id="quotes" style={S.sectionQuotes}>
          <div style={[SS.container, SS.container.narrow, SS.centerer]}>
            <Carousel autoplay={false} easing="easeCubicInOut" wrapAround={true} autoplayInterval={6000}>
              <div className="slide">
                <p style={S.quote}>"Quite impressed with @HaikuForTeams - allows you to design complex animations with GUI and use in an existing Vue app as a component.”</p>
                <div style={S.personHolster}>
                  <div style={S.avatarHolster}><img src={evan} alt="person" /></div>
                  <div>
                    <span style={S.quoteCredsLeft}>
                      <p style={S.name}>Evan You</p>
                      <p style={S.position}>Creator of @vuejs</p>
                    </span>
                    <span style={S.quoteCredsRight}>
                      <img style={S.quoteCompany} src={vue} alt="vue" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="slide">
                <p style={S.quote}>"@HaikuForTeams is one of the most amazing frontend design products I've seen to date, it ended my search for rapid prototyping tools that move from creative to production. Looking forward to improvements to come!”</p>
                <div style={S.personHolster}>
                  <div style={S.avatarHolster}><img src={kwame} alt="person" /></div>
                  <div>
                    <span style={S.quoteCredsLeft}>
                      <p style={S.name}>Kwame Porter Robinson</p>
                      <p style={S.position}>Lead Data Scientist</p>
                    </span>
                    <span style={S.quoteCredsRight}>
                      <img style={S.quoteCompany} src={bh} alt="brighthive" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="slide">
                <p style={S.quote}>"Loving the capabilities of @figmadesign & @HaikuForTeams this month. The best set of tools that we've used for #UI & animation by far! Farewell Sketch & Aftereffects :( #uidesign"</p>
                <div style={S.personHolster}>
                  <div style={S.avatarHolster}><img src={stu} alt="person" /></div>
                  <div>
                    <span style={S.quoteCredsLeft}>
                      <p style={S.name}>Stu Collett</p>
                      <p style={S.position}>Experience & Product Design Director</p>
                    </span>
                    <span style={S.quoteCredsRight}>
                      <img style={S.quoteCompany} src={sus} alt="sus" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="slide">
                <p style={S.quote}>"How is it that I hadn't heard of @HaikuForTeams yet?! Such a compelling product :o"</p>
                <div style={S.personHolster}>
                  <div style={S.avatarHolster}><img src={josh} alt="person" /></div>
                  <div>
                    <span style={S.quoteCredsLeft}>
                      <p style={S.name}>Josh Comeau</p>
                      <p style={S.position}>Software developer</p>
                    </span>
                    <span style={S.quoteCredsRight}>
                      <img style={S.quoteCompany} src={khan} alt="Khan Academy" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="slide">
                <p style={S.quote}>"I've just discovered  @HaikuForTeams and I've fell in love at first sight, I foresee a great future developing animated @vuejs components with @sketchapp designs! #ILoveFrontEndDevelopment"</p>
                <div style={S.personHolster}>
                  <div style={S.avatarHolster}><img src={alvaro} alt="person" /></div>
                  <div>
                    <p style={S.name}>Alvaro Isorna</p>
                    <p style={S.position}>Freelance Full-stack developer</p>
                  </div>
                </div>
              </div>
            </Carousel>
          </div>
        </section>


        <section id="cta" style={S.ctaSection}>
          <CTASVG />
          <div style={[SS.centerer, { position: 'relative', zIndex: 1 }]}>
            <h1 style={[typography.heading1, { color: colors.ivory.color }]}>Free and open source forever</h1>
            <a
              key="cta2"
              style={[SS.btn, SS.cta]}
              href={`https://github.com/HaikuTeam/animator/`}>
              Download on Github
            </a>
          </div>
        </section>

        <MobileContent />
      </div>
    )
  }
}

export default Radium(Animator)



// WEBPACK FOOTER //
// ./src/pages/index.js